import { wrapInList } from "prosemirror-schema-list";
import { TextSelection } from "prosemirror-state";
const insertTodos = (state, dispatch) => {
  return wrapInList(state.schema.nodes.todo_list)(state, dispatch);
};
const toggleTodoItem = (state, pos, todoItemNode) => state.tr.setNodeMarkup(pos, null, {
  done: !todoItemNode.attrs.done
});
const handleTodoClick = (view, node, nodePos) => {
  view.dispatch(toggleTodoItem(view.state, nodePos, node));
  view.focus();
};
export { insertTodos, handleTodoClick };